export const ApiUrl = () => {
    let url = 'https://papi.os-zone.com'
    if (process.env.NODE_ENV !== 'production') {
        url='http://localhost:8000'
      }

      return url
}